import {Basic} from "./Basic";

export class Product
{
    static check_validity(page)
    {
        if(!page)
        {
            page = Product.get_productPage();
        }

        let status = true;
        const submitButton = page.querySelector('.w__button--submit'),
              extras = page.querySelectorAll('.w__input--checkbox:checked');

        if(!page.querySelector('.w__input--radio[name="variant"]:checked'))
        {
            status = false;
        }

        if(page.querySelector('.w__input--radio[name="option"]') &&
          !page.querySelector('.w__input--radio[name="option"]:checked'))
        {
            status = false;
        }

        extras.forEach(e => {
            const p = e.closest('.w__product--option'),
                  myInput = p.querySelector('.w__input--text');

            if(myInput)
            {
                p.querySelector('.w__product--extra-container').dataset.chars = myInput.value.trim().length.toString() +
                                                                                         '/' + myInput.maxLength.toString();

                if(myInput.value.trim().length === 0)
                {
                    status = false;
                }
            }
        });

        if(status === true)
        {
            submitButton.classList.remove('inactive');
        }
        else
        {
            submitButton.classList.add('inactive');
        }

        return status;
    }

    static get_productPage()
    {
        return document.body.querySelector('.w__module.mod--product')
    }

    static set_imageSrc(image, src)
    {
        if(!src)
        {
            src = image.dataset.originalSrc;
        }

        src += '.jpg';

        const paths = [
            Basic.base + 'db/img/product/75x75/'   + src + ' 75w',
            Basic.base + 'db/img/product/150x150/' + src + ' 150w',
            Basic.base + 'db/img/product/250x250/' + src + ' 250w',
            Basic.base + 'db/img/product/500x500/' + src + ' 500w',
            Basic.base + 'db/img/product/800x800/' + src + ' 800w'
        ]

        image.src = Basic.base + 'db/img/product/500x500/' + src;
        image.srcset = paths.join(',');
    }

    static toggle_image(el)
    {
        const image = el.closest('.w__module.mod--product').querySelector(".w__product--section.mod--header .w__tile--image");
        if(image)
        {
            Product.set_imageSrc(image, el.dataset.imageSrc);
        }
    }

    static update_sum()
    {
        let status = false;
        const page = this.get_productPage()

        if(page)
        {
            let sum = 0;
            const sumEl = page.querySelector('.w__product--sum'),
                  options = page.querySelectorAll('.w__input--checkbox:checked,.w__input--radio:checked');
            options.forEach(o => {
                o.closest('.w__product--option').classList.add('active');
                sum += parseFloat(o.dataset.price);
            });
            sumEl.textContent = Basic.return_price(sum);
            status = Product.check_validity(page);
        }

        return status;
    }
}